import { render, staticRenderFns } from "./returnGold.vue?vue&type=template&id=63d72859&scoped=true&"
import script from "./returnGold.vue?vue&type=script&lang=js&"
export * from "./returnGold.vue?vue&type=script&lang=js&"
import style0 from "./returnGold.vue?vue&type=style&index=0&id=63d72859&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d72859",
  null
  
)

export default component.exports